import { collection, getDocs, query, where } from "firebase/firestore";
import { Collection } from "intake_shared/src/enum";
import { LocationStats, OpeningStats } from "intake_shared/src/types";
import moment from "../utils/app_moment";
import db from "../utils/firestore";

const statsCollectionRef = collection(db, Collection.STATS);

export type SavedStats = OpeningStats &
    LocationStats & { report_day: string; last_updated: Date };

export async function getStats(
    from: moment.Moment,
    to: moment.Moment
): Promise<SavedStats[]> {
    const from_string = `${from.startOf("day").toDate().getTime()}`;
    const to_string = `${to.endOf("day").toDate().getTime()}`;
    let stats_query;
    if (from_string !== to_string) {
        stats_query = query(
            statsCollectionRef,
            where("report_day", ">=", from_string),
            where("report_day", "<=", to_string)
        );
    } else {
        stats_query = query(
            statsCollectionRef,
            where("report_day", "==", from_string)
        );
    }
    const docs = (await getDocs(stats_query)).docs.map(
        (d) => d.data() as SavedStats
    );
    return docs;
}
